export const isDescendant = (parent, child) => {
	if (parent === null || child === null) {
		return false;
	}
	let node = child.parentNode;
	while (node !== null) {
		if (node === parent) {
			return true;
		}
		node = node.parentNode;
	}
	return false;
};

export const triggerEvent = (el, type) => {
	let e;
	if ("createEvent" in document) {
		// modern browsers, IE9+
		e = document.createEvent("HTMLEvents");
		e.initEvent(type, false, true);
		el.dispatchEvent(e);
	} else {
		// IE 8
		e = document.createEventObject();
		e.eventType = type;
		el.fireEvent("on" + e.eventType, e);
	}
};

export const setBodyPositionFixed = (setFixed) => {
	if (document.body.style.position || setFixed === false) {
		const windowScroll = document.body.style.top;
		document.body.style.position = null;
		document.body.style.top = null;
		document.body.style.width = null;
		window.scrollTo(0, parseInt(windowScroll || "0") * -1);
	} else {
		const bodyScrollY = window.scrollY;
		document.body.style.position = "fixed";
		document.body.style.top = `-${bodyScrollY}px`;
		document.body.style.width = `${window.innerWidth}px`;
	}
};
